import GraphicTableFilter from "./graphic-table-filter";

const GraphicFilters = {
  Table: GraphicTableFilter,
};

export default GraphicFilters;
